
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import logo from '../../assets/png/logo.png';
import logo from '../../assets/png/logoTransperent.png';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import HeaderRightSection from './headerRightSection';
import { closeHoverSidebar, openHoverSidebar, toggleSidebar } from '../../Redux/Slices/layoutSlice';
import './header.css';
import store from '../../Redux/store';
import CustomPopupForm from '../../component/customPopupModel';
import { MdArrowDropDown } from 'react-icons/md';
import { setIsStripeAccount } from '../../Redux/Slices/counterSlice';
import axiosInstance from '../../configuration/request';
import { useSnackbar } from '../../component/SnackbarContext';
import { isPublicEndpoint } from '../../constants/seo';

const sections = ['home', 'features', 'why-choose-us', 'faq'];

function Header({ isPreAuthRoute = false }) {
  const { loginDetails } = useSelector((state) => state.counter);
   const {isStripeAccount} = useSelector((state) => state.counter);
  const { isSidebarHovered } = useSelector((state) => state.layout);
  const [activeSection, setActiveSection] = useState('home');
  const [logoutPopup, setLogoutPopup] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const isLandingPage = isPublicEndpoint(location.pathname);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
useEffect(() => {
  if (!loginDetails) return;

  if (loginDetails?.stripeAccountId) {
    fetchAccountStatus(loginDetails?.stripeAccountId);
  } else {
    dispatch(setIsStripeAccount(false));
  }
}, [loginDetails]);


    const fetchAccountStatus = (accountID) => {
    axiosInstance
      .get(`/payment/stripe/status/${accountID}`)
      .then((res) => {
         dispatch(setIsStripeAccount(res?.data?.status));
      })
      .catch((error) => {
        showSnackbar(error?.response?.data?.message || "Something went wrong!", "error");
      });
  };
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleRegisterClick = () => {
    navigate('/auth/account');
  };

  const handleScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(id); // manually set on click
    } else {
      navigate('/', { state: { scrollTo: id } });
    }
  };

  useEffect(() => {
    if (!isLandingPage) return;

    const observerOptions = {
      root: null,
      rootMargin: '-100px 0px 0px 0px', // offset for fixed header
      threshold: 0.6, // 60% visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, observerOptions);

    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [isLandingPage]);

  useEffect(() => {
    window.showLogoutPopup = () => setLogoutPopup(true);
  }, []);

  const handleLogoutConfirm = () => {
    store.dispatch({ type: 'RESET_STORE' });
    setLogoutPopup(false);
    navigate('/');
  };

  return (
    <header className={`flex flex-col header-container bg-[var(--bg-header)] z-50 w-full h-20 
    ${(isPreAuthRoute || loginDetails.userType === 'normal user') ? '' : 'justify-center'}`} >
      {(isPreAuthRoute || loginDetails.userType === 'normal user') && (
        <div className="flex justify-center items-center text-[10px] bg-[#1876A9] text-white h-[20px]">
          FIND YOUR SERVICE! EXPLORE
        </div>
      )}

      <div className='py-2 sm:py-0 px-4'  >
        <div className="flex justify-between  h-full" >
          <div className="flex items-center gap-4" >
            {/* <img onClick={() => navigate('/')} src={logo} alt="Logo" className="h-10 sm:h-14 object-contain" /> */}
            <img  src={logo} alt="Logo" className="h-10 sm:h-14 object-contain" />
            {!isPreAuthRoute && loginDetails.userType !== 'normal user' && !isLandingPage && (
              <IconButton
                className="text-black dark:text-white w-10 h-10"
                color="inherit"
                aria-label="menu"
                onClick={() => {
                  if (window.innerWidth >= 768) {
                    dispatch(toggleSidebar()); // >= md
                  } else {
                    if (isSidebarHovered) {
                      dispatch(closeHoverSidebar());
                    } else {
                      dispatch(openHoverSidebar());
                    }
                  }
                }}
              >
                <MenuIcon fontSize="medium" />
              </IconButton>
            )}
          </div>


          {isLandingPage && (
            <nav className="flex items-center gap-6 lgs:gap-12 text-sm font-medium">
              {/* Section links → show only on md+ */}
              <div className="hidden md:flex gap-6 lgs:gap-12">
                {sections.map((id) => (
                  <button
                    key={id}
                    onClick={() => handleScrollTo(id)}
                    className={`transition-colors text-[14px] lgs:text-[16px] ${activeSection === id ? 'text-[#3383B2] font-semibold' : 'text-gray-700'
                      }`}
                  >
                    {id
                      .split('-')
                      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                      .join(' ')}
                  </button>
                ))}
              </div>

              <Link
                to="/marketing"
                className="hidden lg:inline text-[14px] lgs:text-[16px] text-gray-700 hover:text-[#3383B2] transition-colors"
              >
                How It Works
              </Link>
              <Link
                to="/support"
                className="hidden lg:inline text-[14px] lgs:text-[16px] text-gray-700 hover:text-[#3383B2] transition-colors"
              >
                Support
              </Link>

              {/* Operations dropdown → always visible */}
              <div className="relative" ref={dropdownRef}>
                <button
                  type="button"
                  onClick={() => setOpen((prev) => !prev)}
                  className="transition-colors text-[14px] lgs:text-[16px] text-gray-700 hover:text-[#3383B2] flex items-center gap-1"
                  aria-expanded={open}
                >
                  Operations
                  <MdArrowDropDown
                    className={`w-5 h-5 ml-1 transition-transform ${open ? 'rotate-180' : ''
                      }`}
                  />
                </button>
                <div
                  className={`
        absolute left-0 mt-2 w-44 bg-white rounded-md shadow-lg ring-1 ring-black/5
        transition-all duration-200 ease-in-out z-20
        ${open ? 'opacity-100 visible scale-100 pointer-events-auto' : 'opacity-0 invisible scale-95 pointer-events-none'}
      `}
                >
                  <Link
                    to="/delivery-partner"
                    className="block w-full text-left px-6 py-2 text-gray-700 hover:bg-gray-100 hover:text-[#3383B2] transition-colors"
                    onClick={() => setOpen(false)}
                  >
                    Delivery Partner
                  </Link>
                  <Link
                    to="/laundry-business"
                    className="block w-full text-left px-6 py-2 text-gray-700 hover:bg-gray-100 hover:text-[#3383B2] transition-colors"
                    onClick={() => setOpen(false)}
                  >
                    Laundry Business
                  </Link>
                </div>
              </div>
            </nav>

          )}


          {/* Right-side section */}
          <div className="flex items-center gap-4">
            {isLandingPage ? (
              <button onClick={() => handleRegisterClick()}
                type="button"
                className="inline-flex items-center justify-center rounded-lg border-2 border-[#FFFFFF] text-[#FFFFFF] bg-[#1876A9] hover:bg-sky-800 px-5 py-2 text-base font-bold shadow-xl transition"
              >
                Login
              </button>
            ) : (
              !isPreAuthRoute && <HeaderRightSection />
            )}
          </div>
          <CustomPopupForm
            isOpen={logoutPopup}
            handleClose={handleLogoutConfirm}
            dialogType={"session-timeout"}
          />
        </div>
      </div>
    </header>
  );
}

export default Header;
